import styled from "styled-components";

export const ControllerTabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 0 10 247px;
  max-width: 247px;
  min-width: max-content;

  > .tab {
    cursor: pointer;
    height: 72px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 25px;
    line-height: 72px;
    padding: 0 12px;
    text-align: center;
    color: #969696;

    &.selected {
      background: #6436e7;
      color: #fff;
    }
  }
`;
